import "@fontsource/poppins"
import './src/styles/global.css'
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { ClerkProvider } from '@clerk/clerk-react'
// import { Experiment } from '@amplitude/experiment-js-client';

const dev = process.env.NODE_ENV === 'development';

/** Only US (.com) deploys set this at build time. UK primary must stay non-satellite or every visit redirects to sign-in. */
const clerkSatelliteBuild =
  process.env.GATSBY_CLERK_IS_SATELLITE === 'true' ||
  process.env.GATSBY_CLERK_IS_SATELLITE === '1';
const useClerkSatellite = !dev && clerkSatelliteBuild;

/** Primary (UK) auth URLs — required for Clerk satellite (.com) + dev instance; omitted on UK primary. */
const CLERK_PRIMARY_SIGN_IN_URL = 'https://www.theinformationlab.co.uk/auth/login/';
const CLERK_PRIMARY_SIGN_UP_URL = 'https://www.theinformationlab.co.uk/auth/register/';
/** Origins users may be redirected from after signing in on the primary (.co.uk) app — required for safe redirects on satellites. */
const CLERK_PRIMARY_ORIGINS = ['https://www.theinformationlab.co.uk', 'https://theinformationlab.co.uk'];
/** Primary UK app must allow redirects back to the US satellite after auth (Clerk multi-domain). */
const CLERK_US_SATELLITE_ORIGINS = ['https://www.theinformationlab.com', 'https://theinformationlab.com'];

console.log('dev', dev, process.env.NODE_ENV);

// Import your Publishable Key
const PUBLISHABLE_KEY = process.env.GATSBY_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Add your Clerk Publishable Key to the .env file')
}

export const onClientEntry = () => {
	if (window?.location?.hostname !== 'localhost' && window?.location?.hostname.indexOf('vercel.app') === -1) {

		 // Create and Install Session Replay Plugin
		const sessionReplayTracking = sessionReplayPlugin({
			sampleRate: 0.2,
		   });
		amplitude.add(sessionReplayTracking);

		amplitude.init('262b9e31f88b1c89aa641a9b2b2a038e', {"serverZone":"US","autocapture":{"elementInteractions":true}});
	}
}

export  const onRouteUpdate = ({ location, prevLocation }) => {
	const params = new URLSearchParams(location.search);
	const mailchimpUser = params.get('mc_u');
	const mailchimpCampaign = params.get('mc_c');
  const affiliateCode = params.get('aff');

	if (mailchimpUser?.length > 0) {
		amplitude.setUserId(mailchimpUser);
	}

	if (mailchimpCampaign?.length > 0) {
		const event = {
      event_type: 'Mailchimp Campaign',
      event_properties: {
        campaignId: mailchimpCampaign,
      },
    };
    amplitude.track(event);
  }
  
  if (affiliateCode?.length > 0) {
    const event = {
      event_type: 'Affiliate Code',
      event_properties: {
        code: affiliateCode,
      },
    };
    amplitude.track(event);
  }

}

export const wrapRootElement = ({ element }) => {
	return (
      <ParallaxProvider>
        {element}
      </ParallaxProvider>
	);
}

export const wrapPageElement = ({ element, props }) => {
  // if (typeof window !== 'undefined') {

  let clerkSsrState;
  if (props?.serverData?.clerkState) {
    clerkSsrState = props.serverData.clerkState;
    delete props.serverData.clerkState;
  }

  return (
    <ClerkProvider 
      publishableKey={PUBLISHABLE_KEY} 
      clerkState={clerkSsrState || {}} 
      afterSignOutUrl="" 
      touchSession={false} 
      isSatellite={useClerkSatellite}
      domain={useClerkSatellite ? (url) => url.host : undefined}
      signInUrl={useClerkSatellite ? CLERK_PRIMARY_SIGN_IN_URL : undefined}
      signUpUrl={useClerkSatellite ? CLERK_PRIMARY_SIGN_UP_URL : undefined}
      allowedRedirectOrigins={useClerkSatellite ? CLERK_PRIMARY_ORIGINS : CLERK_US_SATELLITE_ORIGINS}
    >
      {element}
    </ClerkProvider>
  );
  
  // }
  // return element;
};


// export const experiment = Experiment.initializeWithAmplitudeAnalytics(
// 	'client-6n5cBLo4IwEfwYWNVBGmJQxdMiRfdwnY'
// );